import * as React from 'react';

import AdminFaq32 from './AdminFaq32';

export const adminFaq32 = () => <AdminFaq32 />;

export default {
    title: 'Icon/Logo/AdminFaq32',
    component: AdminFaq32,
    parameters: {
        notes: "`import AdminFaq32 from 'box-ui-elements/es/icon/logo/AdminFaq32';`",
    },
};
